import { render, staticRenderFns } from "./SystemGiftList.vue?vue&type=template&id=9a6afa46&scoped=true"
import script from "./SystemGiftList.vue?vue&type=script&lang=js"
export * from "./SystemGiftList.vue?vue&type=script&lang=js"
import style0 from "./SystemGiftList.vue?vue&type=style&index=0&id=9a6afa46&prod&lang=scss&scoped=true"
import style1 from "./SystemGiftList.vue?vue&type=style&index=1&id=9a6afa46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6afa46",
  null
  
)

export default component.exports